import { ref } from 'vue'
export interface InsuranceClaimStatus {
  status: string
  description?: string
}
export type InsuranceClaimLookup = (contractNumber: string, claimFile: string) => Promise<InsuranceClaimStatus | null>
export function useInsuranceClaimLookup(lookup: () => InsuranceClaimLookup | undefined) {
  const state = ref<'idle' | 'loading' | 'success' | 'empty' | 'error' | 'unavailable' | 'invalid'>('idle')
  const result = ref<InsuranceClaimStatus | null>(null)
  let request = 0
  function reset() {
    request++
    result.value = null
    state.value = 'idle'
  }
  async function submit(contract: string, folio: string) {
    const current = ++request
    result.value = null
    if (!contract.trim() || !folio.trim()) {
      state.value = 'invalid'
      return
    }
    const service = lookup()
    if (!service) {
      state.value = 'unavailable'
      return
    }
    state.value = 'loading'
    try {
      const response = await service(contract.trim(), folio.trim())
      if (current !== request) return
      result.value = response
      state.value = response ? 'success' : 'empty'
    } catch {
      if (current === request) state.value = 'error'
    }
  }
  return { state, result, submit, reset }
}
